import { type AxiosInstance, HttpStatusCode, isAxiosError } from "axios";
import type { PostCommercialMonitoringFileAPIResponse } from "@/features/commercialRegistrationMonitoring/types";
import { format } from "date-fns";
import { SendToTrackingService } from "@/api/handlers/errors";

interface IProps {
  file: File;
  name: string;
  receptionReasonIds: string[];
  monthlyUpdatable: boolean;
  legalAffairsBureauRequestDateStart: Date;
  legalAffairsBureauRequestDateEnd: Date;
}

export const PostCommercialMonitoringFromFileAPI = async (
  apiClient: AxiosInstance,
  props: IProps
): Promise<PostCommercialMonitoringFileAPIResponse> => {
  const formData = new FormData();
  formData.append("file", props.file);
  formData.append("name", props.name);
  props.receptionReasonIds.forEach((id, index) => {
    formData.append(`receptionReasonIds[${index}]`, id);
  });

  formData.append(
    "monthlyUpdatable",
    props.monthlyUpdatable ? "true" : "false"
  );
  if (!props.monthlyUpdatable) {
    formData.append(
      "legalAffairsBureauRequestDateStart",
      format(props.legalAffairsBureauRequestDateStart, "yyyy-MM-dd")
    );
    formData.append(
      "legalAffairsBureauRequestDateEnd",
      format(props.legalAffairsBureauRequestDateEnd, "yyyy-MM-dd")
    );
  }

  try {
    const response =
      await apiClient.post<PostCommercialMonitoringFileAPIResponse>(
        "/commercial-monitoring/file/",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
      if (
        (error.response?.status ?? HttpStatusCode.InternalServerError) >=
        HttpStatusCode.InternalServerError
      ) {
        SendToTrackingService(error);
      }
    }
    throw error;
  }
};
